/**
 * @generated SignedSource<<e337d1acd83435a78a83806fa6a48a09>>
 * @relayHash da576a4b53c47a4468dd2281290cf7d8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 138485293c0d9134c68e4101a475254588ea57f7b2cc47091d291a639c46afd2

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { FirstCreateViewQuery } from './FirstCreateViewQuery.graphql';

const node: PreloadableConcreteRequest<FirstCreateViewQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "138485293c0d9134c68e4101a475254588ea57f7b2cc47091d291a639c46afd2",
    "metadata": {},
    "name": "FirstCreateViewQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
